import { render } from "./BannerEditorView.vue?vue&type=template&id=0c49ab28&scoped=true"
import script from "./BannerEditorView.vue?vue&type=script&lang=js"
export * from "./BannerEditorView.vue?vue&type=script&lang=js"

import "./BannerEditorView.vue?vue&type=style&index=0&id=0c49ab28&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c49ab28"]])

export default __exports__